/** Mirrors backend ENTITY_CATEGORIES for UI filters and node coloring. */
export const ENTITY_CATEGORIES = [
  'Agent',
  'Process',
  'Resource',
  'Goal',
  'Constraint',
  'Problem',
  'Metric',
  'Belief',
  'Location',
  'Other',
] as const;

export type EntityCategory = (typeof ENTITY_CATEGORIES)[number];

export const CATEGORY_COLORS: Record<string, string> = {
  Agent: '#1976d2',
  Process: '#2e7d32',
  Resource: '#ed6c02',
  Goal: '#9c27b0',
  Constraint: '#795548',
  Problem: '#d32f2f',
  Metric: '#0288d1',
  Belief: '#7b1fa2',
  Location: '#455a64',
  Other: '#757575',
};

export function categoryColor(category: string | undefined): string {
  return CATEGORY_COLORS[category || 'Other'] || CATEGORY_COLORS.Other;
}
